export { ProductRating } from './ProductRating'
